import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'msh-form-input-phone-number',
  imports: [FormsModule],
  template: `
  
      <div class="relative">
        <input
          type="tel"
          [placeholder]="placeholder"
          [(ngModel)]="phoneNumber"
          pattern="^\d*$"
          name="phoneNumber"
          (keyup)="immediatePhoneNumberChange($event)"
          (blur)="phoneNumberChange($event)"
          required
        />
      </div>
  `,
  styles: ``
})
export class FormInputPhoneNumberComponent implements OnChanges {
// FIXME Deal with undefined
  @Input() allowDisplayZero?: boolean;
  @Input() placeholder!: string;
  @Input() phoneNumber?: string = '';
  @Output() onImmediatePhoneNumberChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() onPhoneNumberChange: EventEmitter<string> = new EventEmitter<string>();
  displayPhoneNumber = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['phoneNumber'] && this.phoneNumber !== undefined) {
      
      this.displayPhoneNumber = (this.allowDisplayZero || this.phoneNumber !== '') ? ''+this.phoneNumber : this.placeholder;
    }
  }
  phoneNumberChange(ev: any){
    this.onPhoneNumberChange.emit(this.phoneNumber);
  }
  immediatePhoneNumberChange(ev: any){
    const input = ev.target as HTMLInputElement;
    const originalPhoneNumber = this.phoneNumber || '';
    let digits = originalPhoneNumber.replace(/\D/g, '');
    // Remove leading 0 or 1 
    if(digits.length > 0 && ['0','1'].includes(digits[0]) && !this.allowDisplayZero){
      digits = digits.slice(1);
    }
    const trimmed = digits.slice(0, 10); // Limit to 10 digits for phone number
    let formatted = '';
    if(trimmed.length <=3){
      formatted = trimmed;
    } else if(trimmed.length <=6){
      formatted = `(${trimmed.slice(0,3)}) ${trimmed.slice(3)}`;
    } else {
      formatted = `(${trimmed.slice(0,3)}) ${trimmed.slice(3,6)}-${trimmed.slice(6)}`;
    }
    if( formatted !== originalPhoneNumber){
      const cursorPosition = input.selectionStart || 0;
      const originalLength = originalPhoneNumber.length;
      const formattedLength = formatted.length;

      this.phoneNumber = formatted;

      const diff = formattedLength - originalLength;
      const newCursorPosition = cursorPosition + diff;
      setTimeout(() => {
        input.setSelectionRange(newCursorPosition, newCursorPosition);
      }, 0);
    }
    this.onImmediatePhoneNumberChange.emit(this.phoneNumber);
  }
}
